import RequestState from '../../../types/RequestState';

/**
 * Whether the availability tab should stay visible for the active product.
 * Returns null while stocks or storages are unresolved (loading/error), so
 * callers do not treat pending/failed requests as zero stock.
 *
 * After both datasets resolve: require at least one listed store, then retain
 * the tab when a listed store has positive free_quantity or the active
 * product can be ordered.
 */
const hasListedStoreAvailability = ({
  product,
  activeProductId,
  storageStore,
}) => {
  if (!product || !activeProductId || !storageStore) {
    return null;
  }

  if (
    product.stockStates.get(activeProductId) !== RequestState.LOADED ||
    storageStore.state !== RequestState.LOADED
  ) {
    return null;
  }

  const listingStorages = storageStore.listingStorages;
  if (listingStorages.length === 0) {
    return false;
  }

  const stocks = product.stocks.get(activeProductId) || [];
  const listingStorageIds = new Set(
    listingStorages.map((storage) => storage.id)
  );
  const hasPositiveListedStock = stocks.some(
    (stock) =>
      listingStorageIds.has(stock.storage_id) && Number(stock.free_quantity) > 0
  );

  if (hasPositiveListedStock) {
    return true;
  }

  return product.canBeOrdered(activeProductId);
};

export default hasListedStoreAvailability;
